import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';

import { Container } from './container';

export interface IContainerService {
  getContainers(): Observable<Container[] | null>;
}

@Injectable()
export class ContainerService implements IContainerService {
  readonly baseUrl = '/api/users/current/containers/';

  constructor(private _http: HttpClient) {}

  getContainers(): Observable<Container[] | null> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return this._http.get<Container[] | null>(this.baseUrl).pipe(catchError(error => observableOf(null)));
  }
}
